module.exports = __webpack_public_path__ + "static/img/bb3.08fbb21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bb3.png
// module id = r0c+
// module chunks = 1